export const staticRoutes = [
    {
        link: 'https://artistserve.com/',
        title: 'About',
    },
];
